import { fetcher } from '@chipinside/fetcher'
import { LoadingIconButton } from '@chipinside/frontend'
import { PageBuilderActionProps } from '@chipinside/pagebuilder/dist/types'
import { Translate } from '@chipinside/translate'
import { Button } from '@mui/material'
import { isEmpty } from 'lodash'
import { useState } from 'react'
import { toast } from 'sonner'

import { useFormBuilder } from '#/store/hooks/useFormBuilder'
import { PageBuilderIcon } from '#/store/providers/Pagebuilder/Components/Icon'

const defaultIcons = {
  danger: 'x',
  error: 'x',
  success: 'check',
}

export function PageBuilderAction(props: PageBuilderActionProps) {
  let {
    actionType,
    variant,
    buttonVariant = variant === 'button' ? 'contained' : 'outlined',
    disabled,
    form,
    save,
    level = save.method === 'delete' ? 'danger' : 'success',
    icon = defaultIcons[level],
    message,
    request,
    subtitle,
    title,
  } = props

  const { build, confirm } = useFormBuilder()

  const [throttle, setThrottle] = useState(false)

  // FOI MAL, não queria ter que fazer isso mas não achei outra saida
  const refresh = () => {
    if (request?.mutate) {
      request.mutate().finally(() => setThrottle(false))
    }
  }

  const handleAction = (e: any) => {
    e.stopPropagation()
    e.preventDefault()

    switch (actionType) {
      case 'form': {
        const params = {
          controller: form,
          level,
          save,
          subtitle,
          title,
        }
        build({
          ...props,
          afterSuccess: () => refresh(),
          formName: 'page_builder',
          formType: 'action',
          params,
        })
        break
      }
      case 'confirm': {
        const params = {
          level: 'warning',
          message,
          save,
          subtitle,
          title,
        }
        confirm({
          ...props,
          afterSuccess: () => refresh(),
          formName: 'page_builder',
          formType: 'action',
          params,
        })
        break
      }
      case 'submit': {
        setThrottle(true)
        const promise = fetcher(save)
        toast.promise(promise, {
          error: (response: any) => {
            const errorMessage = Translate({ messageKey: 'something_went_wrong' })
            setThrottle(false)
            return response?.data?.error?.message ?? errorMessage
          },

          loading: Translate({ messageKey: 'loading' }),
          success: (response: any) => {
            refresh()
            const successMessage = Translate({ messageKey: 'action_completed' })
            return response?.data?.message ?? successMessage
          },
        })
      }
    }
  }

  if (variant === 'icon') {
    return (
      <LoadingIconButton
        color={level as any}
        onClick={handleAction}
        disabled={disabled || throttle}
        title={title}
        icon={<PageBuilderIcon value={icon} level={level as any} disabled={disabled} />}
        variant={buttonVariant}
        id={props.id}
      />
    )
  }

  return (
    <>
      <Button
        onClick={handleAction}
        disabled={disabled || throttle}
        color={level as any}
        variant={buttonVariant}
        id={props.id}
        startIcon={!isEmpty(icon) ? <PageBuilderIcon value={icon} /> : undefined}
      >
        {title}
      </Button>
    </>
  )
}
